import React, { useState } from 'react';
import { getTypeOfFile, onDownloadFile } from '../../../common/utils'
import { confirm } from 'devextreme/ui/dialog';
import { isEmpty, isEqual } from "lodash";
import { postUserLog } from "../../../actions/common";
const stat = ["Not Started", "In Progress", "Completed"];
const priority = ["High", "Medium", "Low"];

export const GRID_CONFIG = {

    RPS_GRID_CONFIG: {
        showBorders: true,
        noDataText: "No Actions",
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        export: {
            visible: true
        },
        scrolling: { showScrollbar: "always" },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        editing: {
            mode: "popup",
            allowUpdating: true,
            allowAdding: false,
            allowDeleting: true,
            useIcons: true,
            popup: {
                title: "RPS",
                showTitle: true,
                position: {
                    my: "center",
                    at: "center",
                    of: window
                }
            },
            // form: formActions
        },

        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;

            // Adds a new item
            //toolbarItems.unshift({
            //    location: "after",
            //    widget: "dxButton",
            //    options: {
            //        icon: "refresh",
            //        hint: "Refresh",
            //        onClick: function () {
            //            dataGrid.refresh();
            //        }
            //    }
            //});
        }
    }
}

export const ViewFiles = ({ files, folderName, moreInfo, updateData, onRowUpdated }) => {
    const [fileList, setFiles] = useState(files ? files : [])
    const deleteFile = (obj, f, j) => {
        confirm("Are you sure you want to delete?", "Confirm changes").then((res) => {
            if (res) {
                let fileItems = [...fileList]
                fileItems.splice(j, 1);
                setFiles(fileItems)
                onRowUpdated(f)
                updateData(fileItems)
                return
            }
        })
    }
    const filesTpl = () => {
        if (fileList && fileList.length > 0) {
            return fileList.map((val, index) => {
                return <div key={index}>
                    <a style={{ cursor: 'pointer' }} className="clickable-hover" onClick={() => {
                        getTypeOfFile({ imageName: val, fileExtension: val.split('.')[1] }, folderName)
                    }}>{val}</a>
                    <i style={{ padding: "0px 8px" }} title="Download" className="fa fa-download pointer" onClick={() => onDownloadFile(val, folderName)}></i>
                    <i title="Delete" className="fas fa-trash pointer" onClick={() => deleteFile(moreInfo.data.data, val, index)} ></i>
                </div>
            })
        } else return 'No Attachments.';

    }
    return <span>{filesTpl()}</span>

}


export const postLogForGridOperations = (
    gridRef,
    gridEvent,
    siteUId,
    tierId,
    eventName,
    rpsId,
    navigationOn
  ) => {
    const { name, fullName, value } = gridEvent;
  
    if (
      name === "columns" &&
      !isEmpty(value) &&
      ["filterType", "filterValue", "filterValues"].includes(
        fullName.split(".")[1]
      )
    ) {
      const visibleColumns = gridRef.current.instance.getVisibleColumns();
  
      // Get Column name from caption key if available. else get datafield value
      const colName = visibleColumns.filter((col) =>
        isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
      )[0]?.caption
        ? visibleColumns.filter((col) =>
            isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
          )[0]?.caption
        : visibleColumns.filter((col) =>
            isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
          )[0]?.dataField;
  
      // filtered Individual column
      if (
        fullName.split(".")[1] === "filterValues" &&
        typeof value === "object" &&
        !isEmpty(colName)
      ) {
       
        // postUserLog({
        //   event: `${eventName} Filter`,
        //   data: {
        //     action: `${colName} filtered`,
        //     module: "Digital Tier",
        //     section: navigationOn,
        //     siteUId,
        //     widget: "Structured Problem Solving",
        //     tierId,
        //   },
        // });
      }
  
      if (fullName.split(".")[1] === "filterType") {
        const colName = visibleColumns[fullName.match(/\d+/)]?.caption;
        // if (colName) {
        //   postUserLog({
        //     event: `${eventName} Filter`,
        //     data: {
        //       action: `${colName} filtered`,
        //       module: "Digital Tier",
        //     section: navigationOn,
        //     siteUId,
        //     widget: "Structured Problem Solving",
        //     tierId,
        //     },
        //   });
        // }
      }
    }
  
    if (name === "paging" && fullName.split(".")[1] === "pageIndex") {
      const { previousValue } = gridEvent;
      if (
        Math.abs(value - previousValue) === 1 ||
        (previousValue === undefined && value === 1)
      ) {
      

        postUserLog({
          event: "SPS Grid View",
          data: {
            action: `SPS Grid ${
              previousValue === undefined
                ? "Next"
                : previousValue < value
                ? "Next"
                : "Previous"
            } Page - Page ${value + 1} clicked`,
            module: "Digital Tier",
            section: navigationOn,
            siteUId,
            widget: "Structured Problem Solving",
            tierId,
          },
        });
      }
  
   
    }
    // Page size showing log
    if (name === "paging" && fullName.split(".")[1] === "pageSize") {
      postUserLog({
        event: `${eventName} View`,
        data: {
          action: `SPS Grid expanded to ${value} items`,
          module: "Digital Tier",
          section: navigationOn,
          siteUId,
          widget: "Structured Problem Solving",
          tierId,
        },
      });
    }
  };